import { Button, DatePicker, Modal, ModalProps, Pagination } from "antd";
import styles from "./styles.module.scss";
import classNames from "classnames";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { queryKeys } from "../../../constants/constans";
import {
  getListStaffDuplicate,
  getListTableHistory,
} from "../../../api/tableSession";
import moment from "moment";
import ModalEditTable from "../ModalEditTable";
import { ModalSettingTable } from "../../ModalSettingTable";
import Loader from "../../Loader";

interface IProps extends ModalProps {
  isVisible?: boolean;
  handleCancel: () => void;
}
const ModalTableHistory = (props: IProps) => {
  const { isVisible, handleCancel } = props;
  const [filter, setFilter] = useState<any>({
    date: moment().format("DD-MM-YYYY"),
    pageSize: 10,
    pageIndex: 1,
  });
  const [showModalEdit, setShowModalEdit] = useState<boolean>(false);
  const [tableEdit, setTableEdit] = useState<any>(null);

  const {
    data: listTableSessionHistory,
    isLoading,
    isFetching,
  } = useQuery(
    [queryKeys.historyTable, filter],
    () => getListTableHistory(filter),
    {
      keepPreviousData: true,
    }
  );

  const handleChangeDate = (value?: moment.Moment | null) => {
    if (!value) {
      setFilter((prev: any) => ({ ...prev, date: null }));
      return;
    }
    setFilter((prev: any) => ({ ...prev, date: value.format("DD-MM-YYYY") }));
  };

  const handleShowModalEditTable = (tableInfo: any) => {
    setShowModalEdit(true);
    setTableEdit(tableInfo);
  };

  const handleChangePage = (value: number) => {
    setFilter((prev: any) => ({ ...prev, pageIndex: value }));
  };

  return (
    <>
      <Modal
        open={isVisible}
        footer={null}
        closable={false}
        className={styles.modalDuplicateStaff}
        centered
        width={600}
      >
        <div className={styles.modalSettingContainer}>
          <div className={styles.header}>終了した卓一覧</div>

          <div className={styles.content}>
            <div className={styles.datePickerContainer}>
              <DatePicker
                onChange={handleChangeDate}
                defaultValue={moment()}
                clearIcon={false}
                allowClear={false}
                inputReadOnly={true}
              />
            </div>

            {Array.isArray(listTableSessionHistory?.data) &&
            listTableSessionHistory?.data?.length > 0 ? (
              listTableSessionHistory?.data?.map((item: any) => (
                <div className={styles.container}>
                  <div className={styles.tableItem}>
                    <div className={styles.tableInfo}>
                      <div className={styles.code}>
                        {`${item?.tableConfig?.code}${item?.tableConfig?.no}`}
                      </div>
                    </div>
                    <div className={styles.customerInfo}>
                      <div className={styles.startTime}>
                        {`開始時間: ${moment(
                          item?.dateReal || item?.date
                        ).format("YYYY-MM-DD")} `}
                        {item?.tableConfig?.startTime}
                      </div>
                      <div className={styles.courseTime}>
                        コース時間: {item?.tableConfig?.courseTime}
                      </div>
                      {!!item?.customer && (
                        <div className={styles.customer}>
                          {`名前: ${item?.customer}様`}
                        </div>
                      )}
                    </div>
                    <Button
                      className={styles.btnEdit}
                      onClick={() => handleShowModalEditTable(item)}
                    >
                      編集
                    </Button>
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.noData}>
                該当日の卓のデータがありません。
              </div>
            )}
          </div>

          {Array.isArray(listTableSessionHistory?.data) &&
            listTableSessionHistory?.data > 0 && (
              <div className={styles.paginationContainer}>
                <Pagination
                  pageSize={10}
                  total={listTableSessionHistory?.totalItems}
                  showSizeChanger={false}
                  onChange={handleChangePage}
                  current={filter.pageIndex}
                />
              </div>
            )}

          <div className={styles.btnContainer}>
            <Button
              className={classNames(styles.btn, "btn-default")}
              onClick={handleCancel}
            >
              閉じる
            </Button>
          </div>
        </div>
      </Modal>
      {showModalEdit && (
        <ModalSettingTable
          showModal={showModalEdit}
          id={0}
          infoTable={tableEdit}
          countNextBtn={tableEdit?.step || 0}
          fromHistory={true}
          setShowModal={setShowModalEdit}
        />
      )}
    </>
  );
};
export default ModalTableHistory;
